<template>
  <div>
    <div v-if="!viewText">
      <partnerLink
        :partners="[partner]"
        :programs="programs"
        :viewPartner="true"
        :itemsPerPage="10"
        @getPartners="getPartners"
      />
    </div>
    <div class="pt-4" v-if="!viewText || viewText == 'Sub Partners'">
      <div v-if="!viewText" class="ml-4 pl-4">
        <span class="text-5xl font-weight-bold accent--text">
          SUB PARTNERS
        </span>
      </div>
      <subPartner
        :partnerId="partnerId"
        :partners="partners"
        :subPartners="subPartners"
        :itemsPerPage="itemsPerPage"
        :viewPartner="true"
        @getSubPartners="getSubPartners"
        @viewMore="viewMore"
      />
    </div>
    <div class="pt-4" v-if="!viewText || viewText == 'Branches'">
      <div v-if="!viewText" class="ml-4 pl-4">
        <span class="text-5xl font-weight-bold accent--text"> BRANCHES </span>
      </div>
      <partnerBranch
        :partnerId="partnerId"
        :partners="partners"
        :subPartners="subPartners"
        :partnerBranches="partnerBranches"
        :itemsPerPage="itemsPerPage"
        :viewPartner="true"
        @getpartnerBranches="getpartnerBranches"
        @viewMore="viewMore"
      />
    </div>
  </div>
</template>

<script>
import partnerBranch from "@/components/link/branch.vue";
import subPartner from "@/components/link/subPartner.vue";
import partnerLink from "@/components/link/partner.vue";
import { partnerHeaders } from "@/constants/headers";

export default {
  components: {
    partnerBranch,
    subPartner,
    partnerLink,
  },
  data() {
    return {
      partnerId: null,
      partners: [],
      programPartnerSchedules: [],
      programs: [],
      partner_programs: [],
      subPartners: [],
      partnerBranches: [],
      viewText: null,
      itemsPerPage: 5,
      partner: {},
      headers: partnerHeaders,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.initialise();
  },
  methods: {
    viewMore(value) {
      this.$router.push({
        name: "View Partner Code",
        params: { id: this.partnerId, code: value },
      });
    },
    async initialise() {
      this.partnerId = Number(this.$route.params?.id);
      await this.getPartners();
      await Promise.all([
        this.getPrograms(),
        // this.getPartnerPrograms(),
        this.getSubPartners(),
        this.getpartnerBranches(),
      ]);
    },
    async getPartners() {
      await this.$axios
        .get("partners")
        .then((res) => {
          this.partners = res.data.data;
          this.partner = this.partners.find(
            (item) => item.id == this.partnerId
          );
          const crumbs = [
            { text: "Partners", to: { name: "Partners" } },
            {
              text: this.partner.name,
              to: { name: "View Partner", params: { id: this.partnerId } },
            },
          ];
          if (
            this.$route.params?.code &&
            ["Branches", "Sub Partners", "Programmes"].includes(
              this.$route.params.code
            )
          ) {
            this.viewText = this.$route.params.code;
            this.itemsPerPage = -1;
            crumbs.push({ text: this.$route.params.code });
          } else {
            crumbs[crumbs.length - 1].to = undefined;
          }
          this.$store.commit("setBreadcrumbs", crumbs);
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPartnerPrograms() {
      await this.$axios
        .get(`get_partner_programs/${this.partnerId}`)
        .then((res) => {
          this.partner_programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getPrograms() {
      await this.$axios
        .get("/programs")
        .then((res) => {
          this.programs = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getSubPartners() {
      await this.$axios
        .get("partners?level=S", { params: { parent_id: this.partnerId } })
        .then((res) => {
          this.subPartners = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    async getpartnerBranches() {
      await this.$axios
        .get("partner_branches", { params: { partner_id: this.partnerId } })
        .then((res) => {
          this.partnerBranches = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response.data.message,
            color: "error",
          });
        });
    },
    edit(item) {
      const partner_item = {
        ...item,
        adm_approval_reqd: item.partner_approval_required,
        adm_applicant_fee_collect: item.partner_payment_required,
      };
      this.partner = { ...partner_item };
      this.editMode = true;
      this.dialog = true;
    },
  },
};
</script>

<style></style>
